<template>
  <div class="topbar"><div class="wrap">
    <span><b>{{ site.seasonLabel }}</b> &middot; Now in session &middot; {{ site.seasonTerm }}</span>
    <span class="contact">Have a question? admin@thedreaminc.org</span>
  </div></div>
</template>

<script>
import { SITE } from '@/data/site';

export default {
  name: 'SiteTopbar',
  data: () => ({ site: SITE }),
};
</script>
